import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import "./reslisaStyle.css";
import Switch from "react-bootstrap/esm/Switch";
import JsRealisations from "./JsRealisations";
import ReactJsRealisations from "./ReactJsRealisations";
import MernRealisations from "./MernRealisations";
import SymfonyRealisations from "./SymfonyRealisations";
import ReactNativeRealisations from "./ReactNativeRealisations";
import JavaRealisations from "./JavaRealisations";
import AndroidJavaRealisations from "./AndroidJavaRealisations";
import SideBarRealisations from "./SideBarRealisations";


const Realisations = () => {
    return (
        // <div className="row">
        <BrowserRouter>
            <div className="row">
                <SideBarRealisations />
                <div className="realisations col-10 mt-2 mb-1 px-0">
                    <h5 className="pl-3 text-white"><FaIcons.FaHandPointLeft style={{ color: "#daef0a" }} />Réalisations</h5>
                        <Switch className="pl-2">
                            <Route exact path="/realisations" component={ReactJsRealisations} />
                            <Route path="/realisations/jsRealisations" component={JsRealisations} />
                            <Route path="/realisations/mernRealisations" component={MernRealisations} />
                            <Route path="/realisations/symfonyRealisations" component={SymfonyRealisations} />
                            <Route path="/realisations/reactNativeRealisations" component={ReactNativeRealisations} />
                            <Route path="/realisations/javaRealisations" component={JavaRealisations} />
                            <Route path="/realisations/androidJavaRealisations" component={AndroidJavaRealisations} />
                        </Switch>
                </div>

            </div>
        </BrowserRouter>
        // </div>

    )
}

export default Realisations;
